module.exports = [{"position":"Директор компании","name":"Наталья Свободина","caption":"Главный бухгалтер с 2006 года","image":"/images/personal/natalya.png"}]